import styled from 'styled-components'
import { height, HeightProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<HeightProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 300px;
  flex-grow: 1;
  border-radius: 16px;
  overflow: hidden;
  background-color: ${themeGet('colors.background.screen')};
  box-shadow: ${themeGet('shadows.block')};

  > img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

  ${height}
`

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 300px;
  background-color: ${themeGet('colors.background.screenAlt')};
`

export const Description = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin: 0 0 ${themeGet('space.3')}px;
  }

  a {
    text-decoration: none;
    color: ${themeGet('colors.primary.main')};
    font-weight: ${themeGet('fontWeights.1')};

    &:hover {
      color: ${themeGet('colors.primary.dark')};
    }
  }
`

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.2')}px;
  color: ${themeGet('colors.primary.main')};

  &:hover {
    color: ${themeGet('colors.primary.dark')};
  }
`
